import type { Category } from './api'

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  blue: { bg: 'bg-blue-500/10', text: 'text-blue-700', border: 'border-l-blue-500' },
  emerald: { bg: 'bg-emerald-500/10', text: 'text-emerald-700', border: 'border-l-emerald-500' },
  purple: { bg: 'bg-purple-500/10', text: 'text-purple-700', border: 'border-l-purple-500' },
  cyan: { bg: 'bg-cyan-500/10', text: 'text-cyan-700', border: 'border-l-cyan-500' },
  rose: { bg: 'bg-rose-500/10', text: 'text-rose-700', border: 'border-l-rose-500' },
  gray: { bg: 'bg-gray-500/10', text: 'text-gray-700', border: 'border-l-gray-500' },
  amber: { bg: 'bg-amber-500/10', text: 'text-amber-700', border: 'border-l-amber-500' },
  red: { bg: 'bg-red-500/10', text: 'text-red-700', border: 'border-l-red-500' },
  green: { bg: 'bg-green-500/10', text: 'text-green-700', border: 'border-l-green-500' },
  indigo: { bg: 'bg-indigo-500/10', text: 'text-indigo-700', border: 'border-l-indigo-500' },
  pink: { bg: 'bg-pink-500/10', text: 'text-pink-700', border: 'border-l-pink-500' },
  orange: { bg: 'bg-orange-500/10', text: 'text-orange-700', border: 'border-l-orange-500' },
}

const defaultColor = colorMap.gray

export interface CategoryStyle {
  label: string
  bg: string
  text: string
  border: string
}

export function buildCategoryConfig(categories: Category[]): Record<string, CategoryStyle> {
  const config: Record<string, CategoryStyle> = {}
  for (const cat of categories) {
    const colors = colorMap[cat.color] || defaultColor
    config[cat.slug] = {
      label: cat.name,
      ...colors,
    }
  }
  return config
}

export function getCategoryColorClasses(color: string): { dot: string; badge: string } {
  const normalized = color.toLowerCase()
  const dotByColor: Record<string, string> = {
    blue: 'bg-blue-500',
    emerald: 'bg-emerald-500',
    purple: 'bg-purple-500',
    cyan: 'bg-cyan-500',
    rose: 'bg-rose-500',
    gray: 'bg-gray-500',
    amber: 'bg-amber-500',
    red: 'bg-red-500',
    green: 'bg-green-500',
    indigo: 'bg-indigo-500',
    pink: 'bg-pink-500',
    orange: 'bg-orange-500',
  }
  const badgeByColor: Record<string, string> = {
    blue: 'bg-blue-500/10 text-blue-700',
    emerald: 'bg-emerald-500/10 text-emerald-700',
    purple: 'bg-purple-500/10 text-purple-700',
    cyan: 'bg-cyan-500/10 text-cyan-700',
    rose: 'bg-rose-500/10 text-rose-700',
    gray: 'bg-gray-500/10 text-gray-700',
    amber: 'bg-amber-500/10 text-amber-700',
    red: 'bg-red-500/10 text-red-700',
    green: 'bg-green-500/10 text-green-700',
    indigo: 'bg-indigo-500/10 text-indigo-700',
    pink: 'bg-pink-500/10 text-pink-700',
    orange: 'bg-orange-500/10 text-orange-700',
  }
  return {
    dot: dotByColor[normalized] || 'bg-gray-500',
    badge: badgeByColor[normalized] || 'bg-gray-500/10 text-gray-700',
  }
}

export const AVAILABLE_COLORS = Object.keys(colorMap)
